<template>
  <div class="two-factor-block">
    <h2 class="auth-heading">Enable Two Factor Authentication</h2>
    <v-card-text>


      <div v-if="complete">
        <div class="two-factor-success-block">Two Factor authentication successfully enabled. You must now store your recovery codes</div>

        <h4>Your recovery codes</h4>

        <p>Shown below are your account recovery codes.</p>
        <p><strong style="color: red">These will not be available again, so either copy them below or download and store them in a safe place</strong></p>
        <p>These codes should be treated in the same way as your password, so store them in a safe environment</p>

        <RecoveryCodeView @recoveryStored="markRecoveryStored" :recovery-codes="recoveryCodes"></RecoveryCodeView>

        <div>
          <v-checkbox
            v-model="recoveryStored"
            label="I have stored my recovery codes"
            color="success"
            hide-details
          ></v-checkbox>
        </div>



      </div>

      <div v-else>
        <p>We require your account to have an extra layer of security. This is to ensure your data remains safe and to prevent unauthorised access</p>

        <div>
          <h4>1. Scan the below QR code in your two factor app of choice</h4>
          <vue-qr logoBackgroundColor="#000"
                  :text="twoFactorQR" :size="300" qid="testid"></vue-qr>
          <div>OR enter the code manually: <strong>{{ twoFactorCode }}</strong></div>
        </div>

        <div class="input-number-clear">
          <h4>2. Enter the 6 digit code returned from your two factor app below</h4>
          <v-text-field
            id="code1"
            outlined
            min="0"
            maxLength="6"
            type="number"
            v-model="code"
            class="code-input"
          ></v-text-field>
        </div>
      </div>
    </v-card-text>
    <v-card-actions>

      <v-btn v-if="!complete" class="center-button" color="primary" type="submit" @click="enable2FA">Verify</v-btn>

      <v-btn v-if="complete" :disabled="!recoveryStored" class="center-button" outlined color="primary" type="submit" @click="viewLogin">Go to Login</v-btn>


    </v-card-actions>
  </div>
</template>

<script>
import { get } from 'vuex-pathify';
import VueQr from "vue-qr";
import {recaptcha} from "@/mixins/captcha";
import RecoveryCodeView from "@/views/components/RecoveryCodeView";

export default {
  name: "TwoFactorSet",
  components: {
    VueQr,
    RecoveryCodeView
  },
  mixins: [recaptcha],
  data: () => ({
    code: null,
    recoveryCodes: [],
    complete: false,
    recoveryStored: false
  }),
  computed: {
    ...get('auth', [
      'twoFactorCode',
      'twoFactorQR'
    ]),
    logoPath() {
      return process.env.VUE_APP_UI_URL + "img/icons/192-de.png";
    }
  },
  methods: {
    viewLogin() {
      this.$emit('changeState', "initial");
    },
    markRecoveryStored() {
      this.recoveryStored = true;
    },
    async enable2FA() {
      if (!this.code || this.code.length !== 6) {
        const detail = "Please enter a valid 6 digit code from your Two Factor App";
        await this.$store.dispatch("notification/triggerError", { detail: detail });
        return;
      }

      await this.$store.dispatch("loader/loaderInitiate", { title: "Setting up Two Factor Authentication" });

      const captcha = await this.recaptchaToken();
      const result = await this.$store.dispatch("auth/twoFactorSet", { code: this.code, captcha: captcha });

      await this.$store.dispatch("loader/loaderCancel");

      if (result.success) {
        this.recoveryCodes = result.codes;
        this.complete = true;
        await this.$store.dispatch("notification/triggerSuccess", { detail: "Two Factor Authentication Set" });
      } else {
        this.viewLogin();
      }
    }
  }
}
</script>

<style lang="scss" scoped>


.two-factor-success-block {
  background-color: #83c45d;
  color: white;
  font-weight: bold;
  padding: 10px;
  margin: 10px 20px;
  text-align: center;
}

.two-factor-block {
  text-align: center;
}

h4 {
  margin-top: 15px;
}

.code-input {
  font-size: 1.5rem;
  width: 150px;
  text-align: center;
  margin: 10px auto;


}

#code1 {
  text-align: center;
}

.auth-heading {
  text-transform: none !important;
  background-color: #5d3791;
  color: white !important;
  padding: 15px 10px;
}
</style>
